import { setCookie, getCookie } from "../utils/cookie";
import { addEventListeners } from "../utils/dom";

export default class ThemeSwitcher extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener("show.bs.dropdown", this.handleShow);

        addEventListeners(this.buttons, "click", this.handleSelect);
        
    }

    handleShow = () => {

        const theme = getCookie("theme");

        switch (theme) {
            case "dark":
                this.setSelected(this.querySelector("button[value=dark]"));
                break;
            case "light":
                this.setSelected(this.querySelector("button[value=light]"));
                break;
            default:
                this.setSelected(this.querySelector("button[value=auto]"));
        };

    }

    handleSelect = (e) => {

        const button = e.currentTarget;

        this.clearSelected();
        this.setSelected(button);

        let selectedIcon = button.querySelector(".icon");
        let togglerIcon = this.toggleButton.querySelector(".icon");

        togglerIcon.querySelector("use").replaceWith(selectedIcon.querySelector("use").cloneNode());
        
        document.documentElement.setAttribute("data-bs-theme", button.value);

        setCookie("theme", button.value);
    }

    clearSelected() {
        this.buttons.forEach(button => {
            button.removeAttribute("aria-selected");
            button.classList.remove("active");
        });
    }

    setSelected(button) {
        button.setAttribute("aria-selected", "true");
        button.classList.add("active");
    }

    get buttons() {
        return this.querySelectorAll(".dropdown-item");
    }

    get toggleButton() {
        return this.querySelector("[data-bs-toggle=\"dropdown\"]");
    }

}

customElements.define("theme-switcher", ThemeSwitcher, { extends: "div" });